import { cloneDeep } from 'lodash/lang'
import { findRetailCartProduct } from 'lib/cart/decorators/cartForm'

const setCartAcknowledgedSoftClose = (state, action) => {
  const { camper, session, acknowledged } = action

  // clone so we don't mutate state
  const cartForm = cloneDeep(state)

  // set acknowledgment on the specific cart product for this camper/session
  const cartProduct = findRetailCartProduct({ camper, session, cartForm })
  if (cartProduct) {
    cartProduct.acknowledgedSoftClose = acknowledged
  }

  // return a new state object
  return cartForm
}

export default setCartAcknowledgedSoftClose
